import type { Stat } from '../types'

export const stats: Stat[] = [
  {
    id: 'stat-1',
    value: 150,
    suffix: '+',
    label: 'Projects Delivered',
    icon: '🚀',
  },
  {
    id: 'stat-2',
    value: 98,
    suffix: '%',
    label: 'Client Satisfaction',
    icon: '⭐',
  },
  {
    id: 'stat-3',
    value: 12,
    suffix: '+',
    label: 'Team Experts',
    icon: '👥',
  },
  {
    id: 'stat-4',
    value: 5,
    suffix: '★',
    label: 'Average Rating',
    icon: '🏆',
  },
]
